<template>
  <div id="banner_ad" class="banner"></div>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>

<style lang="sass" scoped>
#banner_ad
  padding: 10px
  margin: 0 auto 50px
</style>
